// extracted by mini-css-extract-plugin
export default {"wraper":"AppRouter_wraper__4nE4Q"};